"use strict";

exports.__esModule = true;
exports.getPosition = void 0;

var _document = require("./document");

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getPosition = function getPosition(position, el) {
  var rect = el.getBoundingClientRect();
  var scrollTop = _document.docScroll.top;
  var scrollLeft = _document.docScroll.left;
  var pos = {};

  switch (position) {
    case 'top-left':
      pos.left = scrollLeft + rect.left;
      pos.top = scrollTop + rect.top;
      break;

    case 'top':
      pos.left = scrollLeft + rect.left + rect.width / 2;
      pos.top = scrollTop + rect.top;
      break;

    case 'top-right':
      pos.right = _document.docSize.width - rect.right - scrollLeft;
      pos.top = scrollTop + rect.top;
      break;

    case 'left-top':
      pos.left = scrollLeft + rect.left;
      pos.top = scrollTop + rect.top;
      break;

    case 'left':
      pos.left = scrollLeft + rect.left;
      pos.top = scrollTop + rect.top + rect.height / 2;
      break;

    case 'left-bottom':
      pos.left = scrollLeft + rect.left;
      pos.top = scrollTop + rect.bottom;
      break;

    case 'right-top':
      pos.left = scrollLeft + rect.left + rect.width;
      pos.top = scrollTop + rect.top;
      break;

    case 'right':
      pos.left = scrollLeft + rect.left + rect.width;
      pos.top = scrollTop + rect.top + rect.height / 2;
      break;

    case 'right-bottom':
      pos.left = scrollLeft + rect.left + rect.width;
      pos.top = scrollTop + rect.bottom;
      break;

    case 'bottom-left':
      pos.left = scrollLeft + rect.left;
      pos.top = scrollTop + rect.top + rect.height;
      break;

    case 'bottom':
      pos.left = scrollLeft + rect.left + rect.width / 2;
      pos.top = scrollTop + rect.top + rect.height;
      break;

    case 'bottom-right':
      pos.right = _document.docSize.width - rect.right - scrollLeft;
      pos.top = scrollTop + rect.top + rect.height;
      break;

    default:
  }

  return Object.keys(pos).reduce(function (data, key) {
    var _objectSpread2;

    return _objectSpread({}, data, (_objectSpread2 = {}, _objectSpread2[key] = Math.round(pos[key]), _objectSpread2));
  }, {});
};

exports.getPosition = getPosition;